


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ConditionOperationType, PickerOption } from '../models/conditions';
import { ConditionViewModel } from '../models/conditionViewModel';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

@Component({
	mixins: [validationMixin],
	validations: {
		liveCondition: {
			value: { required }
		},
	}
})
export default class ListCondition extends Vue {
	@Prop() public condition: ConditionViewModel;
	@Prop() public options: PickerOption[];

	public liveCondition: ConditionViewModel = {
		attribute: '',
		operation: '',
		type: '',
		value: '',
		result: true
	};

	public selectedItem: string = '';

	public mounted() {
		if (this.condition) {
			this.liveCondition = {
				attribute: this.condition.attribute,
				operation: ConditionOperationType.Equals,
				type: this.condition.type,
				value: this.condition.value,
				result: this.condition.result,
				unit: this.condition.unit,
				invalid: this.condition.invalid
			};

			if (this.liveCondition.invalid) {
				this.$v.$touch();
			}
		}

		this.selectedItem = this.getSelectedItemValue();
		this.itemSelected();
	}

	public getSelectedItemValue() {
		if (!this.liveCondition || this.liveCondition.value.length === 0) {
			return this.options[0].id;
		}

		return this.liveCondition.value;
	}

	public itemSelected() {
		this.liveCondition.value = this.selectedItem;
		this.emitConditionChanged();
	}

	private emitConditionChanged() {
		this.liveCondition.invalid = this.$v.$invalid;
		this.$emit('changed', this.liveCondition);
	}

	private complete() {
		this.liveCondition.invalid = this.$v.$invalid;
		this.$emit('completed', this.liveCondition);
	}
}
